<template>
  <b-dropdown :value="value.preset" @input="onPresetActivated" aria-role="list" position="is-bottom-left">
    <button class="button" type="button" slot="trigger">
      <b-icon icon="calendar"></b-icon>
      <span v-if="value.preset === CUSTOM">
        <span class="has-text-grey-light">From:</span> {{ formattedStart }}
        <span class="has-text-grey-light">To:</span> {{ formattedEnd }}
      </span>
      <span v-else>
        <span class="has-text-grey-light">Selected range:</span> {{ presetLabel(value.preset) }}
      </span>
      <b-icon icon="menu-down"></b-icon>
    </button>

    <b-dropdown-item
      v-for="preset in presets"
      :key="preset"
      :value="preset"
      :disabled="selectingRangeInProgress"
      aria-role="listitem">
      <div class="media">
        <div class="media-content">
          <h3>{{ presetLabel(preset) }}</h3>
        </div>
      </div>
    </b-dropdown-item>

    <b-dropdown-item
      :value="CUSTOM"
      custom>
      <template v-if="selectingRangeInProgress">
        Now select end date
        <b-icon icon="loading" size="is-small" custom-class="mdi-spin"></b-icon>
      </template>
      <template v-else>
        Custom date range
      </template>
      <b-field>
        <b-datepicker
          placeholder="Click to select..."
          :value="customDateRange"
          :max-date="new Date()"
          @input="onCustomDatesSelected"
          @range-start="onRangeStart"
          @range-end="onRangeEnd"
          inline
          range>
        </b-datepicker>
      </b-field>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
  import endOfDay from 'date-fns/endOfDay'
  import format from 'date-fns/format'
  import { TODAY, CUSTOM, presetLabel, presets } from '../const'

  export default {
    name: 'DateRangeSelector',
    props: {
      presets: { type: Array, default: () => [...presets] },
      value: { type: Object, default: () => ({ preset: TODAY, start: null, end: null }) }
    },
    data () {
      return {
        selectingRangeInProgress: false,
        CUSTOM
      }
    },
    computed: {
      customDateRange () {
        if (this.value.preset === CUSTOM) {
          return [this.value.start, this.value.end]
        }
        return null
      },
      formattedStart () {
        return format(this.value.start, 'yyy-MM-dd')
      },
      formattedEnd () {
        return format(this.value.end, 'yyy-MM-dd')
      }
    },
    methods: {
      presetLabel (preset) {
        return presetLabel[preset]
      },
      onPresetActivated (preset) {
        const dateRange = {
          preset,
          start: null,
          end: null
        }
        this.$emit('input', dateRange)
      },
      onRangeStart () {
        console.log("started!")
        this.selectingRangeInProgress = true
      },
      onRangeEnd () {
        console.log("ended!")
        this.selectingRangeInProgress = false
      },
      onCustomDatesSelected (customDates) {
        const dateRange = {
          preset: CUSTOM,
          start: customDates[0],
          end: endOfDay(customDates[1])
        }
        this.$emit('input', dateRange)
      }
    }
  }
</script>
